import { AppLoading } from "../../../../../../shared/components/AppLoading";
import { AppUnderlinedTitle } from "../../../../../../shared/components/AppUnderlinedTitle";
import { ChatbotTable } from "./ChatbotTable";
import { NoChatsLabel } from "../../../NoChatsLabel";
import { NormalizedStorageObject } from "../../../../../../services/api/instances/storageApi/types/object_types";
import { AssistantValue } from "../../../../../../services/api/instances/assistantsApi/types";
import { TModalsIds } from "../../../../../../app/state/modalSlice/types";
import { TEntityInfo } from "../../../../../../common/types/utility";
import { ChatObject } from "../../../../../../services/api/instances/botApi/types";
import styles from "./styles.module.css";

interface Props {
  assistants: NormalizedStorageObject<AssistantValue>[];
  handleOpenChangeChatAssistantModal: (
    id: TModalsIds,
    info: TEntityInfo | null,
  ) => void;
  chats: ChatObject[];
  isLoading: boolean;
  title: string;
}

export const ChatbotChatsTable = (props: Props) => {
  return (
    <div className={styles["block-container"]}>
      <AppUnderlinedTitle className={styles.title} leftContent={props.title} />
      {props.isLoading ? (
        <AppLoading small />
      ) : props.chats && props.chats?.length ? (
        <ChatbotTable
          chats={props.chats}
          assistants={props.assistants}
          handleOpenChangeChatAssistantModal={
            props.handleOpenChangeChatAssistantModal
          }
        />
      ) : (
        <NoChatsLabel />
      )}
    </div>
  );
};
